export const GET_MONTHLY_REPORT_LIST = 'VARUNA.GET_MONTHLY_REPORT_LIST'
export const GET_MONTHLY_REPORT_FILE = 'VARUNA.GET_MONTHLY_REPORT_FILE'
export const GET_WEEKLY_REPORT = 'VARUNA.GET_WEEKLY_REPORT'

export const GET_PUMP_REPORT_LIST = 'VARUNA.GET_PUMP_REPORT_LIST'
export const GET_PUMP_REPORT_DETAIL = 'VARUNA.GET_PUMP_REPORT_DETAIL'
export const UPLOAD_PUMP_REPORT = 'VARUNA.UPLOAD_PUMP_REPORT'
